export default __webpack_public_path__ + "static/media/flag-rounded.bfacd412.svg";